import { createEnvelopeSource } from './create-envelope-source';

export const inactivityReturnSource = createEnvelopeSource({
    label: 'Inactivity & return',
    endpoint: 'analytics/inactivity-return',
    metrics: [
        {
            id: 'wentInactiveRate',
            label: 'Went inactive rate',
            type: 'ratio',
        },
        { id: 'cameBackRate', label: 'Came back rate', type: 'ratio' },
    ],
    forms: ['multiline'],
    regionGrain: 'province',
    multilineMetrics: [
        { label: 'Went inactive', metricId: 'wentInactiveRate' },
        { label: 'Came back', metricId: 'cameBackRate' },
    ],
});
